'use client';

import { Chip } from '@packages/shared/src/components/Chip/Chip';
import { Typography } from '@packages/shared/src/components/Typography/Typography';

export type BadgeDVProps = {
  text: string;
};

export const BadgeDV = ({ text }: BadgeDVProps) => (
  <Chip
    label={
      <Typography
        variant="body3"
        color="text.dark"
        sx={{ textTransform: 'uppercase', whiteSpace: 'nowrap' }}
      >
        {text}
      </Typography>
    }
    color="success"
    sx={{
      height: 'auto',
      backgroundColor: 'success.light',
      border: '1px solid',
      borderColor: 'success.main',
    }}
  />
);
